import { WidgetContainer } from "@/layout-components/WidgetContainer";
import LegacyNewsquawkHeadlines from "@/widget-components/newsquawk-headlines/legacy/LegacyNewsquawkHeadlines";
import LegacyHeadlinesSearchForm from "@/widget-components/newsquawk-headlines/legacy/LegacyHeadlinesSearchForm";
import { getWidgetById } from "@/utils/widgets";

// Full-screen /headlines page. Authenticated & live-only (gated by
// ProtectedComponent in App.jsx). Renders the legacy-skinned duplicate of the
// Newsquawk Headlines widget for users who prefer the classic portal view.
function HeadlinesPage() {
  const HeadlinesWidget = getWidgetById("NewsquawkHeadlines");

  return (
    <div className="h-screen flex flex-col">
      <div className="flex-1 min-h-0 p-2">
        {HeadlinesWidget && (
          <WidgetContainer
            widget={HeadlinesWidget}
            searchComponent={LegacyHeadlinesSearchForm}
            hideDefaultActions
            onClose={() => {}}
          >
            {(options) => <LegacyNewsquawkHeadlines headerOptions={options} />}
          </WidgetContainer>
        )}
      </div>
    </div>
  );
}

export default HeadlinesPage;
